exports.apis = {
    'login_admin': '/a/b/c/d/e/f/admin/login',



    'admin_update_profile': '/users/update',
    'admin_update_phone_number': '/users/ChangePhoneNumber',
    'admin_update_password': '/users/changePassword',
    'admin_update_username': '/users/changeusername',
    'admin_pay_user': 'admin/users/pay/',
    'admin_delete_user':'admin/users/delete/',

    
    'admin_get_salary':'admin/users/salary',
    'admin_get_my_profile': '/users/profile',
    'admin_create_category': '/admin/category/store',
    'admin_get_category': '/admin/category/',
    'admin_search_category': '/admin/category/search',
    'admin_update_category': '/admin/category/update/',
    'admin_delete_category': '/admin/category/delete/',

   

    'admin_create_expense': '/admin/expense/store',
    'admin_get_expense': '/admin/expense/',
    'admin_get_expense_public':'/users/expense/',
    'admin_update_expense': '/admin/expense/update',
    'admin_delete_expense': '/admin/expense/delete/',

    'admin_create_rate': '/admin/rate/store',
    'admin_update_rate':'/admin/rate/update',
    'admin_get_rate': '/admin/rate/',
    'admin_update_transaction': '/admin/transaction/update/',
    'admin_delete_rate': '/admin/rate/delete/',

    'admin_create_inc': '/admin/inc/store',
    'admin_get_inc': '/admin/inc/',
    'admin_update_inc': '/admin/inc/update',
    'admin_delete_inc': '/admin/inc/delete/',
    

    'admin_create_menu_category': '/admin/menu/category/store',
    'admin_get_menu_category': '/admin/menu/category/',
    'admin_search_menu_category': '/admin/menu/category/search',
    'admin_update_menu_category': '/admin/menu/category/update/',
    'admin_delete_menu_category': '/admin/menu/category/delete/',

    'admin_create_menu': '/admin/menu/store',
    'admin_get_menu': '/admin/menu/get/',
    'admin_get_menu_for_linking': '/admin/menu/from/store',
    'admin_search_menu': '/admin/menu/search',
    'admin_update_menu': '/admin/menu/update/',
    'admin_delete_menu': '/admin/menu/delete/',
    'admin_payed_order':'/admin/casher/paye/',
   
    'admin_get_users': '/admin/users/',
    'admin_get_waiter_users': '/admin/users/waiter',
    'admin_get_all_users': '/users/get/all',
    'admin_create_user': '/admin/users/register',
    'admin_update_user': '/admin/users/update/',
    'admin_disable_user': '/admin/users/disable/',
    'admin_enable_user': '/admin/users/enable/',
    'admin_password_user': '/admin/users/change/password/',
    'admin_filter_user': '/admin/users/search',
    'admin_get_teachers':'/users/get/teachers/',

    
    'admin_get_students': '/admin/students',
    'admin_get_all_students': '/students/get/all',
    'admin_create_student': '/admin/students/store/',
    'admin_update_student': '/admin/students/update/',
    'admin_filter_student': '/admin/students/search',
    'admin_print_recipt_student':'/admin/students/update/print/',

    'admin_get_class':'/admin/menu/class/get',
    'admin_get_class_all':'/admin/menu/class/get/all',
    'admin_get_attendance':'/admin/schedule/today',
    'admin_attendance':'/admin/schedule/take/attendance/',
    'admin_get_attendance_history':'/admin/schedule/attendance/history',
    'admin_delete_attendance':'/admin/schedule/attendance/history/delete/',

"admin_search_percent":'/teacher/percent/search',
"admin_get_percent":'/teacher/percent/',
"admin_delete_percent":'/teacher/percent/delete/',
"admin_update_percent":'/teacher/percent/update/',
"admin_create_percent":'/teacher/percent/store',
'admin_get_teacher_class':'/teacher/class/',
'admin_get_percent_class':'/teacher/percent/get/class/',
'admin_get_students_class':'/teacher/students/',
'admin_get_students_class_rank':'/teacher/students/rank/',
'admin_delete_students':'/admin/students/delete/',
'admin_update_Mark':'/teacher/students/mark/update',
'admin_pay_student':'/admin/students/pay/',
'admin_return_student':'/admin/students/return/',
'admin_active_student':'/admin/students/holdunhold/',
"admin_search_schedule":'/admin/schedule/search/',
"admin_get_schedule":'/admin/schedule/',
"admin_delete_schedule":'/admin/schedule/delete/',
"admin_update_schedule":'/admin/schedule/update/',
"admin_create_schedule":'/admin/schedule/create/',

'admin_get_report_cahser':'/admin/report/',
'admin_reported':'/admin/report/reported/',
'admin_get_report_folder':'/admin/report/get/folder',
'admin_done_casher':'/admin/report/done/',
'admin_get_recipt_all':'/admin/students/recipt',
'admin_permissions_user':'/users/permission',
"admin_get_students_detail":'/admin/students/ranked',
'admin_filter_student_detail':'/admin/students/ranked/search',
'admin_get_all_payed_orders':'/admin/report/casher/print/',
'admin_get_all_expense_orders':'/admin/report/expense/print/',
'admin_get_all_expense_orders_both':'/admin/report/both/print/',
'admin_get_report_delete':'/admin/report/casher/delete/',
'admin_delete_salary':'/admin/report/salary/delete/',


'admin_get_transaction':'/users/transaction',
'admin_filter_transaction':'/users/transaction/filter/',
'admin_create_transaction':'admin/transaction/create',
'admin_delete_transaction':'users/transaction/delete/',



'admin_get_transaction_admin':'/admin/transaction',
'admin_filter_transaction_admin':'/admin/transaction/filter/',
'admin_accept_transaction_admin':'/admin/transaction/accept/',
'admin_done_transaction_admin':'/admin/transaction/done/',
'admin_reject_transaction':'/users/transaction/reject/',


'guest_get_expense': '/country',
'guest_get_rate': '/rate',
'guest_get_inc': '/tf',


'admin_create_bank': '/admin/bank/store',
'admin_get_bank': '/admin/bank/',
'admin_search_bank': '/admin/bank/search',
'admin_update_bank': '/admin/bank/update',
'admin_delete_bank': '/admin/bank/delete/',

'admin_update_note':'users/transaction/note/update/',
'admin_update_note_status':'users/transaction/note/state/update/',
'admin_pay_transaction':'users/transaction/pay/',

'admin_get_transaction_summary':'/users/transaction/summary',
'admin_get_transaction_admin_summary':'/admin/transaction/summary',


};